export default __webpack_public_path__ + "static/media/without_shadow.c3ee9f2e.png";